import React, { useEffect, useMemo, useState } from 'react';
import { Markdown as MD } from '@features/markdown/components/Markdown';
import Element from './Element';

const Horizontal = ({ children = [], ...props }) => {
    return (<div className='tw-mx-auto tw-grid tw-w-full tw-max-w-[600px] tw-grid-cols-2 tw-justify-center tw-gap-5 lg:tw-max-w-[1225px] lg:tw-justify-between lg:tw-grid-cols-4'>
        {children.map((c,i) => <Element key={i} {...c}/>)}
    </div>);
};

const HorizontalBlurb = ({ title, text, image }) => {
    return (
        <div className='tw-max-w-[250px] tw-text-center tw-mx-auto'>
            {image && <img src={image.url} alt={title} className='tw-mx-auto tw-mb-4 tw-block tw-h-full tw-max-h-[50px] tw-w-full tw-max-w-[70px]'/>}
            {title && <p className='tw-mb-2 tw-text-base tw-font-bold md:tw-text-lg'>{title}</p>}
            {text && <p className='tw-mb-0 tw-text-sm tw-font-normal tw-leading-tight md:tw-text-base'><MD source={text}/></p>}
        </div>
    );
}

export default Horizontal;